<template>
    <div class="mt-5">
        <div class="h1 my-2">訂單列表</div>
        <table ref="list" class="table mt-4">
            <thead>
                <tr>
                    <th>訂單編號</th>
                    <th width="120">付款狀態</th>
                    <th>付款人</th>
                    <th>金額</th>
                    <th>付款方式</th>
                    <th>訂單建立時間</th>
                    <th>到款時間</th>
                </tr>
            </thead>
            <tbody v-for="item, index in orderList.data" :key="index" @click="goToOrderInformation(item.my_trade_no)">
                <tr style="background-color: rgb(245, 245, 245);">
                    <td>{{ item.my_trade_no }}</td>
                    <td>{{ item.rtn_msg }}</td>
                    <td>{{ item.order_name }}</td>
                    <td>{{ item.total_amount }}</td>
                    <td>{{ item.payment_type }}</td>
                    <td>{{ convertTimeFormat(item.created_at) }}</td>
                    <td>{{ item.paid ?? "尚未付款" }}</td>
                </tr>
            </tbody>
        </table>
        <div style="display: flex; justify-content: space-between;">
            <div>第 {{ orderList.current_page }} 頁 / 共 {{ orderList.last_page }} 頁</div>
            <div>顯示 {{ orderList.to ?? 0 }} 筆 / 共 {{ orderList.total }} 筆</div>
        </div>
        <div style="display: flex; justify-content: center;">
            <button class=" btn btn-sm btn-outline-secondary" v-show="orderList.first_page_url"
                v-on:click="getOrderItem(orderList.first_page_url)">第 1 頁</button>
            <button class="btn btn-sm btn-outline-secondary" v-show="orderList.prev_page_url"
                v-on:click="getOrderItem(orderList.prev_page_url)">上一頁</button>
            <button class="btn btn-sm btn-outline-secondary" v-show="orderList.next_page_url"
                v-on:click="getOrderItem(orderList.next_page_url)">下一頁</button>
            <button class=" btn btn-sm btn-outline-secondary" v-show="orderList.first_page_url"
                v-on:click="getOrderItem(orderList.last_page_url)">最後一頁</button>
        </div>
    </div>
</template>

<script>
import jQuery from 'jquery';
export default {
    data() {
        return {
            base_url,
            orderList: [],
        }
    },
    methods: {
        getorder: function () {
            axios
                .get(base_url + '/admin/api/orders')
                .then((response) => {
                    this.orderList = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getOrderItem: function (url) {
            axios.get(url)
                .then((response) => {
                    this.orderList = response.data;
                }).catch(function (error) {
                    console.log(error);
                });
        },
        goToOrderInformation: function (orderUuid) {
            location.href = base_url + '/admin/order/' + orderUuid;
        },
        convertTimeFormat: function (time) {
            let UTC_time = new Date(time);
            console.log(UTC_time);
            let local_time = new Date(UTC_time.setHours(UTC_time.getHours() + 8));
            let year = local_time.getFullYear();
            let month = local_time.getMonth() + 1;
            let date = local_time.getDate();
            let hour = local_time.getHours();
            let min = local_time.getMinutes();
            let sec = local_time.getSeconds();
            return year + '-' +
                month.toString().padStart(2, '0') + '-' +
                date.toString().padStart(2, '0')
                + ' ' + hour.toString().padStart(2, '0') + ':' +
                min.toString().padStart(2, '0') + ':' +
                sec.toString().padStart(2, '0');
        }
    },
    created() {
        this.getorder();
    },
}
</script>
